import { useEffect } from "react";
import store from "../appStore";

const LoadingCallback = (props) => {
  useEffect(() => {
    store.loadingFinished = false;
    return () => {
      store.loadingFinished = true;
    };
  }, []);
  return null;
};

export default LoadingCallback;
